import React from 'react';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import PencilIcon from '@buyside/svgs/pencil.svg';

import { newMacroThematicUrl } from '@buyside/util/urlHelper';

import styles from './styles.scss';

export type WhitePaperStatusBarDraftProps = {
  id: string;
};

const WhitePaperStatusBarDraft: React.FC<WhitePaperStatusBarDraftProps> = ({ id }) => {
  return (
    <div className={styles.container}>
      <strong>Preview Mode</strong> &mdash; You are currently previewing a draft of your thematic
      research report.
      <Button
        url={newMacroThematicUrl(id)}
        type={BUTTON_TYPES.LINK}
        text="BACK TO EDITING"
        className={styles.editButton}
        icon={PencilIcon}
      />
    </div>
  );
};
export default WhitePaperStatusBarDraft;
